import { client } from "../index";
import type {
  GetTagsByIdsResponse,
  RecommendTagsResponse,
  SearchTagsResponse,
} from "./types";

// =============================================================================
// API Endpoints
// =============================================================================

export const endpoints = {
  TagsByIds: (ids: string) => `/tags/ids/${ids}`,
  RecommendTags: "/tags/recommend",
  SearchTags: (query: string) => `/tags/search/${query}`,
};

// =============================================================================
// API Functions
// =============================================================================

/**
 * GET /tags/ids/{ids} - Get Tags By IDs
 * @param ids - Space-separated list of tag IDs (e.g., "159391 195274")
 * @param signal - Optional abort signal
 */
export const getTagsByIds = async (
  ids: number[] | string,
  signal?: AbortSignal
): Promise<GetTagsByIdsResponse> => {
  const idsString = Array.isArray(ids) ? ids.join(" ") : ids;
  const response = await client.get(endpoints.TagsByIds(idsString), { signal });

  return response.data;
};

/**
 * POST /tags/recommend - Get Recommended Tags
 * @param content - Text content to analyze for tag recommendations
 * @param signal - Optional abort signal
 */
export const fetchRecommendedTags = async (
  content: string,
  signal?: AbortSignal
): Promise<RecommendTagsResponse> => {
  const response = await client({
    method: "POST",
    url: endpoints.RecommendTags,
    data: { text: content },
    signal,
  });

  return response.data;
};

/**
 * GET /tags/search/{query} - Search Tags
 * @param query - Search query string
 * @param signal - Optional abort signal
 */
export const searchTags = async (
  query: string,
  signal?: AbortSignal
): Promise<SearchTagsResponse> => {
  const response = await client.get(endpoints.SearchTags(query), { signal });

  return response.data;
};
